import api from './api';
import { authService } from './authService';

export const floorService = {
  getFloors: async () => {
    try {
      const response = await api.get('/api/business/floors');
      return response.data;
    } catch (error) {
      console.error('Error fetching floors:', error);
      throw error;
    }
  },

  getFloor: async (floorId) => {
    try {
      const response = await api.get(`/api/business/floors/${floorId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching floor:', error);
      throw error;
    }
  },

  createFloor: async (floorData) => {
    try {
      const response = await api.post('/api/business/floors', floorData);
      return response.data;
    } catch (error) {
      console.error('Error creating floor:', error);
      throw error;
    }
  },

  updateFloor: async (floorId, floorData) => {
    try {
      const response = await api.put(`/api/business/floors/${floorId}`, floorData);
      return response.data;
    } catch (error) {
      console.error('Error updating floor:', error);
      throw error;
    }
  },

  deleteFloor: async (floorId) => {
    try {
      const response = await api.delete(`/api/business/floors/${floorId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting floor:', error);
      throw error;
    }
  },
};

